import { render } from "./VerticalProgressBar.vue?vue&type=template&id=4831146c&scoped=true"
import script from "./VerticalProgressBar.vue?vue&type=script&lang=js"
export * from "./VerticalProgressBar.vue?vue&type=script&lang=js"

import "./VerticalProgressBar.vue?vue&type=style&index=0&id=4831146c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4831146c"]])

export default __exports__